import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n'; // Initialize i18n before App
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installInteractionListeners } from './services/interactionSignal';

// #1220: start observing genuine user gestures so the api interceptor can tag
// only user-initiated requests as interactive (de-noises "Last Active" / WAU).
installInteractionListeners();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
